import { z } from 'zod';
// E.164: + ile baslar, 8-15 hane (ITU E.164 standardi)
const e164 = z.string().regex(/^\+[1-9]\d{7,14}$/, 'E.164 formatinda telefon (orn. +905321234567)');
// 1. SMS kodu iste — telefon gonderir, oturumId doner
export const musteriSmsIstegi = z.object({
    telefon: e164,
});
export const musteriSmsCevabi = z.object({
    oturumId: z.string(),
    sonKullanmaSn: z.number().int(), // kodun gecerlilik suresi (saniye)
    testKodu: z.string().optional(), // SADECE lokal/test ortaminda — canli'da null
});
// 2. Kodu dogrula — telefon + 6 haneli kod, JWT seti doner
export const musteriDogrulamaIstegi = z.object({
    telefon: e164,
    kod: z.string().regex(/^\d{6}$/, '6 haneli kod gerekli'),
});
// Musteri ozeti — mobile profil/menu/cuzdan icin tam alan seti
export const musteriOzeti = z.object({
    id: z.string(),
    telefon: z.string(),
    adSoyad: z.string().nullable(),
    eposta: z.string().nullable(),
    dilTercihi: z.enum(['tr', 'en']),
    cuzdanBakiyesi: z.string(), // Decimal serileştirilmiş
    dogumTarihi: z.string().nullable(), // ISO YYYY-MM-DD veya null
    cinsiyet: z.enum(['KADIN', 'ERKEK', 'BELIRTILMEMIS']),
});
export const musteriOturumCevabi = z.object({
    erisimJeton: z.string(),
    yenilemeJeton: z.string(),
    erisimSuresiSn: z.number().int(),
    yenilemeSuresiSn: z.number().int(),
    musteri: musteriOzeti,
});
// 3. Refresh token ile yenile
export const musteriYenilemeIstegi = z.object({
    yenilemeJeton: z.string().min(10),
});
// 4. Cikis (refresh iptal)
export const musteriCikisIstegi = z.object({
    yenilemeJeton: z.string().min(10).optional(),
});
//# sourceMappingURL=musteri-oturum.js.map